<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/', 'lieferscheine', 'suche', 'index']"> Lieferscheine </a>
      </li>
      @if (deliveryNote) {
        <li>
          <a [routerLink]="['/', 'lieferscheine', deliveryNote.related_note_id]">
            {{ deliveryNote.related_note_number }}
          </a>
        </li>
        <li>{{ deliveryNote.number }}</li>
      } @else {
        <li>
          <span class="bm-loading bm-loading-spinner"></span>
        </li>
      }
    </ul>
  </div>

  @if (deliveryNote) {
    <a [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'edit']" class="btn btn-ghost">
      <i class="fa fa-pencil"></i>
      Bearbeiten
    </a>
    <button [disabled]="deliveryNote.status !== 'PREPARED'" (click)="onDelete()" class="bm-btn bm-btn-error">
      <i class="fas fa-trash-alt"></i>
      Lieferschein löschen
    </button>
  }
</div>

<div class="page-content page-frame">
  <div class="page-sheet w-full h-full flex flex-col">
    @if (deliveryNote) {
      <ng-component [ngTemplateOutlet]="tplNoteList" />
      <ng-component [ngTemplateOutlet]="tplInfos" />
      <ng-component [ngTemplateOutlet]="tplShipping" />

      <ag-grid-angular
        class="ag-theme-quartz h-full"
        [theme]="hawkTheme"
        [loadThemeGoogleFonts]="true"
        [defaultColDef]="defaultColDef"
        [columnDefs]="colDefs"
        [rowClassRules]="rowClassRules"
        [rowSelection]="rowSelection"
        [localeText]="locale"
        [rowData]="articles"
        [alwaysShowVerticalScroll]="true"
      >
      </ag-grid-angular>
    }
  </div>
</div>

<ng-template #tplNoteList>
  <ul class="flex flex-row gap-4">
    <li class="flex-1 bm-alert bm-alert-success flex flex-col gap-2">
      <h4 class="font-bold">Lieferschein</h4>
      <a class="bm-btn bm-btn-secondary bm-btn-block" [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'edit']">
        Bearbeiten
      </a>
      <a
        class="bm-btn bm-btn-primary bm-btn-block"
        [href]="env.apiURL + 'delivery_notes/' + deliveryNote.id + '.pdf'"
        target="_blank"
      >
        <i class="fa fa-print mr6"></i>Drucken
      </a>
    </li>
    <!-- Block: Label START Here -->
    <li class="flex-1 bm-alert bm-alert-success flex flex-col gap-2">
      <h4 class="font-bold">Label</h4>
      @if (
        deliveryNote.related_note_id &&
        deliveryNote.related_note_data &&
        deliveryNote.related_note_data.shipcloud_label_url
      ) {
        <a
          href="{{ deliveryNote.related_note_data.shipcloud_label_url }}"
          class="bm-btn bm-btn-primary bm-btn-block"
          target="_blank"
        >
          <i class="fa fa-print mr6"></i>
          Drucken
        </a>
      }
    </li>
    <!-- Block: Label END Here -->

    <!-- Block: Sendung START Here -->
    @if (deliveryNote.retoure) {
      <li class="flex-1 bm-alert bm-alert-warning flex flex-col gap-2">
        <h4 class="font-bold">Sendung</h4>
        <div class="text-center mb12 d-flex gap-2 justify-content-center align-items-center">
          <span class="label label-default label-own d-flex gap-2">
            {{
              deliveryNote.related_note_data.shipcloud_retoure_tracking_status
                ? deliveryNote.related_note_data.shipcloud_retoure_tracking_status
                : "Unbekannt"
            }}
            @if (!deliveryNote.related_note_id) {
              <span> Unbekannt </span>
            }
          </span>
          <a
            href="/warehouse/deliveryNote/{{ deliveryNote.id }}/checkShipcloudTrackingStatus"
            class="bm-btn bm-btn-secondary bm-btn-square"
            ><i class="fa fa-refresh" aria-hidden="true"></i
          ></a>
        </div>
        <a
          href="{{ deliveryNote.related_note_data.shipcloud_retoure_tracking_url }}"
          class="bm-btn bm-btn-primary bm-btn-block"
          target="_blank"
        >
          Tracking
        </a>
      </li>
    } @else {
      @if (deliveryNote.status === "PREPARED") {
        <li class="flex-1 bm-alert bm-alert-warning flex flex-col gap-2">
          <h4 class="font-bold">Sendung</h4>
          <div class="text-center btn-white mb12" style="margin-top: 18px">-</div>
        </li>
      } @else {
        @if (deliveryNote.shipping_by === "SHIPCLOUD") {
          <li class="flex-1 bm-alert bm-alert-success flex flex-col gap-2">
            <h4 class="font-bold">Sendung</h4>
            <div class="text-center mb12 d-flex gap-2 justify-content-center align-items-center">
              <span class="label label-default label-own text-white">
                {{ deliveryNote.shipcloud_tracking_status ? deliveryNote.shipcloud_tracking_status : "Unbekannt" }}
              </span>
              <a
                href="/warehouse/deliveryNote/{{ deliveryNote.id }}/checkShipcloudTrackingStatus"
                class="bm-btn bm-btn-secondary bm-btn-square"
              >
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </a>
            </div>
            <a
              href="{{ deliveryNote.shipcloud_tracking_url }}"
              class="bm-btn bm-btn-primary bm-btn-block"
              target="_blank"
            >
              Tracking
            </a>
          </li>
        } @else {
          @if (deliveryNote.shipping_by === "OTHER") {
            <li class="flex-1 bm-alert bm-alert-success flex flex-col gap-2">
              <h4 class="font-bold">Sendung</h4>
              <div class="text-center text-white white mb12" style="margin-top: 18px">
                No: {{ deliveryNote.shipping_other_carrier_tracking_no }}
              </div>
            </li>
          } @else {
            <li class="flex-1 bm-alert bm-alert-success flex flex-col gap-2">
              <h4 class="font-bold">Sendung</h4>
              <div class="text-center text-white mb12" style="margin-top: 18px">-</div>
            </li>
          }
        }
      }
    }
    <!-- Block: Sendung END Here -->
    <!-- Block: Empfang START Here -->
    @if (deliveryNote.status !== "RECEIPT") {
      <li class="flex-1 bm-alert bm-alert-warning flex flex-col gap-2">
        <h4 class="font-bold">Empfang</h4>
        <div class="text-center btn-white mb12" style="margin-top: 18px">-</div>
        <a
          [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'quittieren']"
          class="bm-btn bm-btn-primary bm-btn-block"
        >
          Quittieren
        </a>
      </li>
    } @else {
      <li class="flex-1 bm-alert bm-alert-success flex flex-col gap-2">
        <h4 class="font-bold">Empfang</h4>
        <div class="text-center text-white mb12" style="margin-top: 18px">
          quittiert am <br />{{ deliveryNote.receipt_date | date: "dd.MM.yyyy" }}
        </div>
      </li>
    }
    <!-- Block: Empfang END Here -->
  </ul>
</ng-template>

<ng-template #tplInfos>
  <div class="flex flex-row">
    <section class="bm-card bm-card-sm flex-1">
      <div class="bm-card-body p-4">
        <h2 class="bm-card-title bm-divider">Absender</h2>
        <table class="bm-table bm-table-xs">
          <tr>
            <th>Firma</th>
            <td>{{ deliveryNote.sender_address_company || "-" }}</td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{{ deliveryNote.sender_address_firstname }} {{ deliveryNote.sender_address_lastname }}</td>
          </tr>
          <tr>
            <th>Straße</th>
            <td>{{ deliveryNote.sender_address_street || "-" }} {{ deliveryNote.sender_address_street_no }}</td>
          </tr>
          <tr>
            <th>PLZ und Ort</th>
            <td>{{ deliveryNote.sender_address_zip }} {{ deliveryNote.sender_address_city }}</td>
          </tr>
          <tr>
            <th>Land (Staat)</th>
            <td>
              {{ deliveryNote.sender_address_country }}
              @if (deliveryNote.sender_address_state) {
                <span>({{ deliveryNote.sender_address_state }})</span>
              }
            </td>
          </tr>
        </table>
      </div>
    </section>
    <section class="bm-card bm-card-sm flex-1">
      <div class="bm-card-body p-4">
        <h2 class="bm-card-title bm-divider">Empfänger</h2>
        <table class="bm-table bm-table-xs">
          <tr>
            <th>Firma</th>
            <td>{{ deliveryNote.recipient_address_company || "-" }}</td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{{ deliveryNote.recipient_address_firstname }} {{ deliveryNote.recipient_address_lastname }}</td>
          </tr>
          <tr>
            <th>Straße</th>
            <td>{{ deliveryNote.recipient_address_street || "-" }} {{ deliveryNote.recipient_address_street_no }}</td>
          </tr>
          <tr>
            <th>PLZ und Ort</th>
            <td>{{ deliveryNote.recipient_address_zip }} {{ deliveryNote.recipient_address_city }}</td>
          </tr>
          <tr>
            <th>Land (Staat)</th>
            <td>
              {{ deliveryNote.recipient_address_country }}
              @if (deliveryNote.recipient_address_state) {
                <span>({{ deliveryNote.recipient_address_state }})</span>
              }
            </td>
          </tr>
        </table>
      </div>
    </section>
    <section class="bm-card bm-card-sm flex-1">
      <div class="bm-card-body p-4">
        <h2 class="bm-card-title bm-divider">Lieferung</h2>
        <table class="bm-table bm-table-xs">
          <tr>
            <th>Nummer</th>
            <td>{{ deliveryNote.number }}</td>
          </tr>
          <tr>
            <th>Erstellt</th>
            <td>{{ deliveryNote.note_date | date: "dd.MM.yyyy" }}</td>
          </tr>
          <tr>
            <th>Auftrag (altes Feld)</th>
            <td>{{ deliveryNote.order_number || "-" }}</td>
          </tr>
          <tr>
            <th>Tickets</th>
            <td>
              @for (ticket of deliveryNote.tickets_data || []; track ticket) {
                <div>
                  <a
                    [routerLink]="['/', 'ticket', ticket.id]"
                    class="g-link d-flex align-items-center gap-2"
                    target="_blank"
                    ><i class="fa fa-ticket mr6"></i>{{ ticket.external_order_nr || ticket.order_nr }}</a
                  >
                </div>
              }
            </td>
          </tr>
          <tr>
            <th>Info</th>
            <td>{{ deliveryNote.info }}</td>
          </tr>
        </table>
      </div>
    </section>
    <section class="bm-card bm-card-sm flex-1">
      <div class="bm-card-body p-4">
        <h2 class="bm-card-title bm-divider">Paket</h2>
        <table class="bm-table bm-table-xs">
          <tr>
            <th>Status</th>
            <td>
              @if (deliveryNote.status === "PREPARED") {
                <span class="label label-own label-default">Vorbereitet</span>
              }
              @if (deliveryNote.status === "SHIPPED") {
                <span class="label label-own label-warning">Versandt</span>
              }
              @if (deliveryNote.status === "DELIVERED") {
                <span class="label label-own label-success">Zugestellt</span>
              }
              @if (deliveryNote.status === "RECEIPT") {
                <span class="label label-own label-success">Quittiert</span>
              }
            </td>
          </tr>
          <tr>
            <th>Paketmaße</th>
            <td>
              @if (deliveryNote.parcel_height || deliveryNote.parcel_width || deliveryNote.parcel_length) {
                <span>
                  {{ deliveryNote.parcel_height }} cm / {{ deliveryNote.parcel_width }} cm /
                  {{ deliveryNote.parcel_length }} cm
                  <span class="pull-right text-muted"> (H/B/L) </span>
                </span>
              }
            </td>
          </tr>
          <tr>
            <th>Gewicht</th>
            <td>
              @if (deliveryNote.parcel_weight) {
                <span> {{ deliveryNote.parcel_weight }} kg </span>
              }
            </td>
          </tr>
          <tr>
            <th>E-Mail</th>
            <td>
              {{ deliveryNote.notification_email || "-" }}
            </td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</ng-template>

<ng-template #tplShipping>
  <div class="flex flex-row">
    @if (deliveryNote.shipping_by === "SHIPCLOUD") {
      <section class="bm-card bm-card-sm flex-1">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title bm-divider">Shipcloud</h2>
          <table class="bm-table bm-table-xs">
            <tr>
              <th>Carrier</th>
              <td>
                <span class="f-bold bold">{{ deliveryNote.shipcloud_carrier }}</span>
                {{ deliveryNote.shipcloud_service }}
                @if (deliveryNote.shipcloud_test) {
                  <span class="label label-own label-default pull-right">Nur Test</span>
                }
              </td>
            </tr>
            <tr>
              <th>Sendung erstellt</th>
              <td>
                {{ deliveryNote.shipping_date | date: "dd.MM.yyyy" }}
              </td>
            </tr>
            <tr>
              <th>Carrier-Tracking</th>
              <td>{{ deliveryNote.shipcloud_carrier_tracking_no }}</td>
            </tr>
            <tr>
              <th>Tracking-URL</th>
              <td>
                <a href="{{ deliveryNote.shipcloud_tracking_url }}" target="_blank" class="bm-link bm-link-hover"
                  >Tracking</a
                >
              </td>
            </tr>
            <tr>
              <td class="text-right text-muted">Preis:</td>
              <td>
                <span>{{ deliveryNote.shipcloud_price | currency: "€" }}</span>
              </td>
            </tr>
            @if (deliveryNote.shipcloud_retoure_shipcloud_id) {
              <tr>
                <td class="text-right text-muted">Retoure-Label:</td>
                <td>Wurde erstellt</td>
              </tr>
            }
            @if (!deliveryNote.shipcloud_retoure_shipcloud_id) {
              <tr>
                <td class="text-right text-muted">Retoure-Label:</td>
                <td>
                  <a
                    [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'shipping-retoure']"
                    class="bm-link bm-link-hover"
                  >
                    Retoure-Label erstellen
                  </a>
                </td>
              </tr>
            }
          </table>
        </div>
      </section>
    }
    @if (deliveryNote.shipping_by === "SHIPCLOUD") {
      <section class="bm-card bm-card-sm flex-1">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title bm-divider">Abholung</h2>
          <table class="bm-table bm-table-xs">
            @if (deliveryNote.shipcloud_pickup_id) {
              <tbody>
                <tr>
                  <td class="text-right text-muted">Zeit:</td>
                  <td>
                    @if (deliveryNote.shipcloud_test) {
                      <span class="label label-default label-own pull-right">Nur Test</span>
                    }
                    {{
                      deliveryNote.shipcloud_pickup_id && deliveryNote.shipcloud_pickup_data.earliest
                        | date: "dd.MM.yyyy HH:mm"
                    }}
                    - <br />
                    {{
                      deliveryNote.shipcloud_pickup_id && deliveryNote.shipcloud_pickup_data.latest
                        | date: "dd.MM.yyyy HH:mm"
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="text-right text-muted">Adresse:</td>
                  <td>
                    <div class="d-flex gap-1">
                      @if (deliveryNote.shipcloud_pickup_data.pickup_address_company) {
                        <span> {{ deliveryNote.shipcloud_pickup_data.pickup_address_company }}, </span>
                      }
                      @if (
                        deliveryNote.shipcloud_pickup_data.pickup_address_firstname ||
                        deliveryNote.shipcloud_pickup_data.pickup_address_lastname
                      ) {
                        <span>
                          {{ deliveryNote.shipcloud_pickup_data.pickup_address_firstname }}
                          {{ deliveryNote.shipcloud_pickup_data.pickup_address_lastname }}
                        </span>
                      }
                    </div>
                    <div class="d-flex gap-1">
                      @if (
                        deliveryNote.shipcloud_pickup_data.pickup_address_street ||
                        deliveryNote.shipcloud_pickup_data.pickup_address_street_no
                      ) {
                        <span>
                          {{
                            [
                              deliveryNote.shipcloud_pickup_data.pickup_address_street,
                              deliveryNote.shipcloud_pickup_data.pickup_address_street_no,
                            ].join(" ")
                          }},
                        </span>
                      }
                      @if (
                        deliveryNote.shipcloud_pickup_data.pickup_address_city ||
                        deliveryNote.shipcloud_pickup_data.pickup_address_zip
                      ) {
                        <span>
                          {{
                            [
                              deliveryNote.shipcloud_pickup_data.pickup_address_city,
                              deliveryNote.shipcloud_pickup_data.pickup_address_zip,
                            ].join(" ")
                          }},
                        </span>
                      }
                      @if (deliveryNote.shipcloud_pickup_data.pickup_address_country) {
                        <span>
                          {{ deliveryNote.shipcloud_pickup_data.pickup_address_country }}
                        </span>
                      }
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-right text-muted">Telefon:</td>
                  <td>
                    {{ deliveryNote.shipcloud_pickup_data.phone || "-" }}
                  </td>
                </tr>
              </tbody>
            }
            @if (!deliveryNote.shipcloud_pickup_id) {
              <tbody>
                <tr>
                  <td class="text-right text-muted">Abholung:</td>
                  @if (["UPS", "DPD"].includes(deliveryNote.shipcloud_carrier)) {
                    <td>
                      <div>-</div>
                      <div class="mt8 mb4 d-flex">
                        <a
                          class="bm-link bm-link-hover"
                          [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'pickup']"
                        >
                          <i class="fa fa-clock-o mr6"></i>Abholzeit festlegen
                        </a>
                      </div>
                    </td>
                  }
                  @if (!["UPS", "DPD"].includes(deliveryNote.shipcloud_carrier)) {
                    <td>Abholung nur mit UPS oder DPD möglich.</td>
                  }
                </tr>
              </tbody>
            }
          </table>
        </div>
      </section>
    }
    @if (deliveryNote.shipping_by === "OTHER") {
      <section class="bm-card bm-card-sm flex-1">
        <div class="bm-card-body p-4">
          <h2 class="bm-card-title bm-divider">Anderer Versand</h2>
          <table class="bm-table bm-table-xs">
            <tr>
              <td class="text-right text-muted" style="width: 35%">Carrier:</td>
              <td>
                <span class="bold">{{ deliveryNote.shipping_other_carrier }}</span>
                {{ deliveryNote.shipping_other_service }}
              </td>
            </tr>
            <tr>
              <td class="text-right text-muted">Sendung erstellt:</td>
              <td>
                {{ deliveryNote.shipping_date | date: "dd.MM.yyyy" }}
              </td>
            </tr>
            <tr>
              <td class="text-right text-muted">Carrier-Tracking:</td>
              <td>{{ deliveryNote.shipping_other_carrier_tracking_no }}</td>
            </tr>
            <tr>
              <td class="text-right text-muted">info:</td>
              <td>{{ deliveryNote.shipping_other_info }}</td>
            </tr>
            <tr>
              <td class="text-right text-muted">Preis:</td>
              <td>
                @if (deliveryNote.shipping_other_price && deliveryNote.shipping_other_price >= 0) {
                  <span>{{ deliveryNote.shipping_other_price | currency: "€" }}</span>
                }
                @if (!deliveryNote.shipping_other_price || deliveryNote.shipping_other_price < 0) {
                  <span>-</span>
                }
              </td>
            </tr>
          </table>
        </div>
      </section>
    }
  </div>
</ng-template>
